export class NyhederPageConstants{
    public static nyhederPageLength = 5;
}
